import {
  createNavigationContainerRef,
  CommonActions,
  StackActions,
} from "@react-navigation/native";

export const navigationRef = createNavigationContainerRef<any>();

export function navigate(
  name: string,
  params?: object,
  additionalParams?: object
) {
  if (navigationRef.isReady()) {
    // Use dispatch with CommonActions.navigate for cross-navigator navigation
    navigationRef.dispatch(
      CommonActions.navigate({
        name,
        params,
        ...additionalParams,
      })
    );
  } else {
    console.warn("Navigation not ready yet");
  }
}

export function navigateNested(
  navigatorName: string,
  screenName: string,
  params?: object
) {
  if (navigationRef.isReady()) {
    navigationRef.dispatch(
      CommonActions.navigate({
        name: navigatorName,
        params: {
          screen: screenName,
          params,
        },
      })
    );
  } else {
    console.warn("Navigation not ready yet");
  }
}

export function goBack() {
  if (navigationRef.isReady() && navigationRef.canGoBack()) {
    navigationRef.goBack();
  }
}

export function reset(routeName: string, params?: object) {
  if (navigationRef.isReady()) {
    navigationRef.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name: routeName, params }],
      })
    );
  }
}

export function push(name: string, params?: object) {
  if (navigationRef.isReady()) {
    navigationRef.dispatch(StackActions.push(name, params));
  }
}

export function replace(name: string, params?: object) {
  if (navigationRef.isReady()) {
    navigationRef.dispatch(StackActions.replace(name, params));
  }
}
